import React from 'react'
import injectSheet from 'react-jss'
import Wrapper from '../../../../wrapper/wrapper'
import Container from '../../../../container/container'
import Description from '../../../../description/description'
import Footer from '../../../../footer/footer'
import Button from 'pobble-components/dist/button'
import FormWrapper from '../../../../form-wrapper/form-wrapper'

const TermsAndConditions = injectSheet({
  link: {
    textDecoration: 'underline !important',
    color: 'var(--gray-) !important',
    fontWeight: 'normal !important'
  },
  desc: {
    '& > p': {
      margin: '16px 0'
    }
  }
})(({ classes, onAccept, pending }) => {
  return (
    <Wrapper>
      <Container noHead>
        <Description noBorder title="Welcome to Pobble 🎉">
          <div className={classes.desc}>
            <p>
              <strong>Let's finish setting up your account</strong>
            </p>
            <p>
              By continuing you accept our
              <br />
              <a
                className={classes.link}
                href="https://www.pobble.com/terms-of-service"
                target="_bank">
                terms
              </a>{' '}
              and{' '}
              <a
                href="https://www.pobble.com/privacy-policy"
                target="_bank"
                className={classes.link}>
                privacy policy
              </a>
            </p>
          </div>
        </Description>
        <FormWrapper pending={pending}>
          <Footer dense>
            <Button darkBlue pending={pending} action={onAccept} wide tall>
              Next
            </Button>
          </Footer>
        </FormWrapper>
      </Container>
    </Wrapper>
  )
})

export default TermsAndConditions
